import { GeoJSON } from 'react-leaflet';
import { electricPurple600 } from '@habitech/shared';

import { GeoJsonPolygon } from '../../../types';

interface SubjectPolygonProps {
  poligono: GeoJsonPolygon;
}

export const SubjectPolygon = ({ poligono }: SubjectPolygonProps) => {
  if (!poligono.coordinates?.length || !poligono.coordinates[0]?.length) {
    return null;
  }

  const feature: GeoJSON.Feature = {
    type: 'Feature',
    properties: {},
    geometry: poligono as GeoJSON.Geometry,
  };

  return (
    <GeoJSON
      data={feature}
      style={{
        color: electricPurple600,
        weight: 2,
        fillColor: electricPurple600,
        fillOpacity: 0.08,
        dashArray: '6 4',
      }}
    />
  );
};
